export const CARD_TABLE_EDGES = '[&_tr>*:first-child]:pl-6 [&_tr>*:last-child]:pr-6'

export type WidthColumn = {
  id: string
  truncate?: boolean | undefined
  size?: number | undefined
}

export function truncatedWidths(columns: readonly WidthColumn[]): Map<string, string> {
  const truncated = columns.filter((column) => column.truncate === true)
  const total = truncated.reduce((sum, column) => sum + weightOf(column), 0)
  return new Map(
    truncated.map((column) => [
      column.id,
      `${Math.round((weightOf(column) / total) * 1000) / 10}%`,
    ]),
  )
}

function weightOf(column: WidthColumn): number {
  return column.size !== undefined && column.size > 0 ? column.size : 1
}
